export default __webpack_public_path__ + "static/media/aboriginal.ba1edf92.svg";